import { render } from "./VimeoVideoModal.vue?vue&type=template&id=cad66cac&scoped=true"
import script from "./VimeoVideoModal.vue?vue&type=script&lang=js"
export * from "./VimeoVideoModal.vue?vue&type=script&lang=js"

import "./VimeoVideoModal.vue?vue&type=style&index=0&id=cad66cac&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cad66cac"]])

export default __exports__